__turbopack_context__.v({
  "bar": "UtilityBar-module-scss-module__tvbwrW__bar",
  "fade-in": "UtilityBar-module-scss-module__tvbwrW__fade-in",
  "label": "UtilityBar-module-scss-module__tvbwrW__label",
  "no-transform": "UtilityBar-module-scss-module__tvbwrW__no-transform",
  "rotate": "UtilityBar-module-scss-module__tvbwrW__rotate",
});
